import { render } from "./SplitSection.vue?vue&type=template&id=f4be5232"
import script from "./SplitSection.vue?vue&type=script&lang=js"
export * from "./SplitSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__